"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function pax(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M19.5867 9.97342L19.9617 10.5359C20.7117 8.64592 20.5392 7.16842 19.8642 6.52342C18.6492 5.35342 16.8642 6.00592 14.9292 5.19592C13.3167 4.01092 12.3417 3.69592 10.9992 3.69592C10.0822 3.85366 9.23335 4.28201 8.5617 4.92592C8.02016 4.89425 7.47821 4.98044 6.97322 5.17856C6.46823 5.37667 6.01224 5.68198 5.6367 6.07342C4.8417 7.01092 4.6617 9.58342 4.5417 10.2359C4.4217 10.8884 3.0417 13.5209 3.1842 14.9609C3.3267 16.4009 4.3842 17.9609 7.3767 18.3284C7.93151 18.9728 8.6238 19.4845 9.4026 19.8259C10.1814 20.1673 11.0269 20.3296 11.8767 20.3009C13.4442 20.1359 15.6267 17.7359 16.8942 16.7834C18.1617 15.8309 22.6767 15.0059 19.9842 10.5734C19.8688 10.3797 19.7436 10.192 19.6092 10.0109L19.5867 9.97342ZM12.7392 16.5734C11.5991 16.7946 10.4176 16.6115 9.39782 16.0558C8.37806 15.5001 7.58383 14.6064 7.1517 13.5284C6.9867 12.8834 6.6642 9.59842 9.4017 7.97092C11.4417 6.81592 14.3142 6.65842 15.5217 9.35092C16.7292 12.0434 16.2867 15.8159 12.7392 16.5734Z", fill: color }));
}
exports["default"] = pax;
//# sourceMappingURL=pax.js.map